export default "__VITE_ASSET__DckwpYM___"